<template>
  <table class="list-anonymisations">
    <thead>
      <tr>
        <th />
        <th>
          <div>
            <div><i class="fa-solid fa-shield-halved" /></div>
            <div>{{ $t("label.access") }}</div>
          </div>
        </th>
        <th>
          <div>
            <div><i class="fa-solid fa-user-doctor" /></div>
            <div>{{ $t("label.staffs") }}</div>
          </div>
        </th>
        <th>
          <div>
            <div><i class="fa-solid fa-person-cane" /></div>
            <div>{{ $t("label.residents") }}</div>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th>{{ $t("label.number_anonymised") }}</th>
        <td>{{ getAnonymisationsNumber(anonymisationData?.access) }}</td>
        <td>{{ getAnonymisationsNumber(anonymisationData?.staffs) }}</td>
        <td>{{ getAnonymisationsNumber(anonymisationData?.residents) }}</td>
      </tr>
      <tr>
        <th>{{ $t("label.last_anonymisation_date") }}</th>
        <td>{{ getLastAnonymisationDate(anonymisationData?.access) }}</td>
        <td>{{ getLastAnonymisationDate(anonymisationData?.staffs) }}</td>
        <td>{{ getLastAnonymisationDate(anonymisationData?.residents) }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { getAnonymisations } from '../../services/establishment';

export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading: false,

      anonymisationData: {
        access: [],
        staffs: [],
        residents: [],
      },
    };
  },
  async created() {
    this.loading = true;
    this.anonymisationData = await getAnonymisations(this.id)
    this.loading = false;
  },
  methods: {
    getAnonymisationsNumber(anonymisations) {
      return (anonymisations?.length ?? 0) > 0 ? anonymisations?.length : "-"
    },
    getLastAnonymisationDate(anonymisations) {
      if ((anonymisations?.length ?? 0) === 0) {
        return "-"
      }
      let maxDate = -1;

      anonymisations.forEach(anom => {
        const date = new Date(anom.date);

        if (date > maxDate) {
          maxDate = date
        }
      });

      return maxDate.toLocaleString();
    }
  }
};
</script>

<style scoped>
.list-anonymisations {
  margin: auto;

  thead {
    border-bottom: 2px solid rgba(0, 0, 0, 0.2);
  }

  tbody{
    tr:not(:last-child) {
      border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    }
  }

  th, td {
    font-size: 1rem;
    padding: 0.5em 1em;

    &:first-child {
      border-right: 2px solid rgba(0, 0, 0, 0.2);
    }

    &:not(:last-child, :first-child) {
      border-right: 1px solid rgba(0, 0, 0, 0.2);
    }
  }

  th {
    font-size: 1.25rem;
  }
}
</style>